import type { QueryClient } from '@tanstack/react-query'
import { z } from 'zod'

import { marketEndpoints } from '@/api/endpointCache'
import {
  homeMoverRowSchema,
  type HomeMoverRow,
  type HomeMoversSide,
} from '@/features/home/api/homeSchemas'

const PREVIEW_LIMIT = 5

/**
 * Home's own payload, read the way the rail reads its two: straight off `marketEndpoints(client)`
 * rather than through `useMarketOverview()` (a 10-endpoint fan-out for a 2-list read) or
 * `useMovers()` (the full Market · Movers table). A side is the wire's own `type`, `gainers` or
 * `losers`. See `homeSchemas.ts` for the row.
 */
export const homeService = {
  movers: async (side: HomeMoversSide, client?: QueryClient): Promise<HomeMoverRow[]> => {
    const api = marketEndpoints(client)
    const page = await api.movers({ type: side, limit: PREVIEW_LIMIT })
    return z.array(homeMoverRowSchema).parse(
      page.rows.map((row) => ({
        symbol: row.key,
        name: row.name,
        ltp: row.ltp,
        percentChange: row.change_percent,
      })),
    )
  },
}
